import { Component, OnInit } from '@angular/core';
import {SeoService} from '../../../../services/seo/seo.service';

@Component({
  selector: 'app-geo-env-sci-society',
  templateUrl: './geo-env-sci-society.component.html',
  styleUrls: ['./geo-env-sci-society.component.scss']
})
export class GeoEnvSciSocietyComponent implements OnInit {

  constructor(private seo: SeoService) { }

  ngOnInit(): void {
    this.seo.setMeta('Geographical and Environmental Science Society');
  }

}
